import { render } from "./PlanetChart.vue?vue&type=template&id=0c46fcc4&scoped=true"
import script from "./PlanetChart.vue?vue&type=script&lang=js"
export * from "./PlanetChart.vue?vue&type=script&lang=js"

import "./PlanetChart.vue?vue&type=style&index=0&id=0c46fcc4&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c46fcc4"]])

export default __exports__